// 文件操作公有方法
import { Base64 } from 'js-base64'
import { Message } from 'element-ui'
import common from '@comm/utils/common'
import { saveAs } from 'file-saver';
import jsx from 'babel-plugin-syntax-jsx';
const APIPort = process.env.APIPort;
// 预览
/**
 * @description: 在线查看文档
 * @param {*} fileIds 文件id
 */

export function readApi (name,url,type) {
  let fileUrl = Base64.encode(name + "|" + url);
  fileUrl = encodeURIComponent(fileUrl)
  let webUrl = localStorage.getItem('webUrl')?localStorage.getItem('webUrl'):common.baseurl
  const href = `${webUrl}?file=${fileUrl}`
    const el = document.createElement('a')
    el.href = href
    el.target = type?'_self':'_blank'
    document.body.appendChild(el)
    el.click()
  
}

export function downloadFile (type,res,file, downBack) {
  if (!res) {
    Message.error('下载文件失败')
    return false
  }
  let filename = res.headers['filename']
  filename = decodeURIComponent(filename)
  const blob = new Blob([res.data])
  if(sessionStorage.getItem("browserType")=='IE'){
    saveAs(blob, filename);
  }else{
  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  downloadElement.download = filename
  // downloadElement.download = file.file.filename
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放blob对象
  }
  downBack(type,file)
}

export default {
  readApi,
  downloadFile
}



// WEBPACK FOOTER //
// ./src/comm/utils/files.js